module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0745.21f6e2d9.jpg";